<bp-svg-shared-icons-definitions></bp-svg-shared-icons-definitions>

<bp-svg-payment-card-brands-icons-definitions></bp-svg-payment-card-brands-icons-definitions>

<content [@routeHitAnimations]="shouldAnimateOutlet" (@routeHitAnimations.done)="shouldAnimateOutlet = false">
	<router-outlet (activate)="shouldAnimateOutlet = true"></router-outlet>
</content>

<bp-footer *ngIf="environment.isNotProduction || (mediaService.greaterThan$('PhoneLg') | async)"></bp-footer>
